export default __webpack_public_path__ + "static/media/flexiAcct.adb797d9.png";